import * as service from './service'
export default {
  namespace: 'MiddleJump',
  state: {
    jumpData: {}
  },
  effects: {
    * jumpUrlData ({ payload }, { call, put }) {
      const res = yield call(service.jumpUrlData, payload)
      const { jumpData } = res.data.data
      yield put({
        type: 'save',
        payload: {
          jumpData
        }
      })
      return res.data
    }
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
